module.exports = __webpack_public_path__ + "static/media/player-detection.c8483f94.svg";